import { createAction, createFeatureSelector, createReducer, createSelector, on, props } from '@ngrx/store';

import { RocFilter } from '../interfaces/roc-list-item';

export const rocReportTransientFeatureKey = 'roc-report-transient';

export interface RocReportStateTransient {
  filter: RocFilter;
}

export const initialState: RocReportStateTransient = {
  filter: {
    //Real initial state is setting in '\roc.effects.ts' with next affect `setInitialDateData`
    beginDate: null,
    endDate: null,
  },
};

export const setRocFilter = createAction('[Roc] setRocFilter', props<{ filter: RocFilter }>());
export const setInitialDateDataSuccess = createAction(
  '[Roc] setInitialDateDataSuccess',
  props<{ filter: RocFilter }>()
);
export const setInitialDateData = createAction('[Roc] set initial date state success');

export const reducer = createReducer(
  initialState,
  on(setRocFilter, (state, action) => ({
    ...state,
    ...{ filter: action.filter },
  })),
  on(setInitialDateDataSuccess, (state, action) => ({
    ...state,
    filter: action.filter,
  }))
);

export const selectRocReportState = createFeatureSelector<RocReportStateTransient>(rocReportTransientFeatureKey);
export const selectRocFilter = createSelector(selectRocReportState, state => state.filter);
export const selectRocFilterSet = createSelector(
  selectRocReportState,
  state => !!state.filter.beginDate && !!state.filter.endDate
);
